import { defineComponent as r, openBlock as n, createElementBlock as o, createElementVNode as s, normalizeClass as i, toDisplayString as t, createCommentVNode as l } from "vue";
const a = { class: "flex flex-col" }, c = {
  key: 0,
  class: "inline-block leading-none"
}, p = { class: "inline-block text-base leading-none md:text-xl" }, d = { class: "text-right text-sm text-gray-500 line-through" }, u = /* @__PURE__ */ r({
  __name: "BulkDiscountPrice",
  props: {
    prefix: {},
    regularPrice: {},
    salesPrice: {}
  },
  setup(m) {
    return (e, _) => (n(), o("div", a, [
      s("div", {
        class: i(["gap-1 font-bold", { "text-pink": e.regularPrice }])
      }, [
        e.prefix ? (n(), o("span", c, t(e.prefix) + " ", 1)) : l("", !0),
        s("span", p, t(e.salesPrice), 1)
      ], 2),
      s("div", d, t(e.regularPrice), 1)
    ]));
  }
});
export {
  u as _
};
